import { useEffect, useState, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import CustomSlider from "../../customSlider/CustomSlider";

import { LoadingDot } from "../../UI/spinners/LoadingSpinners";
import { getCategoryInfos } from "../../Map/utils";
import { MeteoInfoDataContext } from "../../../hooks/context";
import { useAllContexts } from "../../../hooks/useAllContexts";

const Meteor = ({ typeId }) => {
  const [categoryData, setCategoryData] = useState(null);
  const { meteoInfoData, loading } = useContext(MeteoInfoDataContext);
  const { environment, bins, hum } = useAllContexts();

  useEffect(() => {
    setCategoryData(getCategoryInfos(typeId));
  }, []);

  const renderProblem = () => {
    return (
      <p
        style={{
          fontWeight: "600",
          fontSize: "14px",
          paddingTop: "10px",
          color: "#333",
        }}
      >
        Αδυναμία λήψης δεδομένων λόγω προβλήματος
      </p>
    );
  };

  const renderItems = (start, end, items) => {
    const tempItems = [];
    for (let itemIndex = start; itemIndex < end; itemIndex++) {
      tempItems.push(items[itemIndex]);
    }

    return tempItems.map((item, index) => {
      return (
        <div key={`${item.group_name}_index`}>
          <BoxEntity
            key={index}
            icon={`https://korydallos.smartiscity.gr/gallery/vars/Big/${item.sensorvar_icon}`}
            content={item.group_name}
            value={`${parseInt(item.group_val).toFixed(2)} ${
              item.sensorvar_unit
            }`}
            // date={item.date_insert}
          />
        </div>
      );
    });
  };

  return (
    <>
      {loading && <LoadingDot />}
      <BoxTitle
        icon={`im ${categoryData?.icon}`}
        title={categoryData?.title?.toUpperCase()}
        link={`/map?typeId=${typeId}`}
        infoContext={categoryData?.tooltip}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
        id={typeId}
      />
      {typeId === "5" &&
        (meteoInfoData?.length > 0 ? (
          <CustomSlider>
            {meteoInfoData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  <BoxSubTitle>{infoItem.sensor_address}</BoxSubTitle>
                  {infoItem.details.map((infoDetail, index) => {
                    return (
                      <BoxEntity
                        key={index}
                        icon={`https://korydallos.smartiscity.gr/gallery/vars/Big/${infoDetail.sensorvar_icon}`}
                        content={infoDetail.sensorvar_description}
                        value={`${parseInt(infoDetail.measurement).toFixed(
                          2
                        )} ${infoDetail.sensorvar_unit}`}
                        date={infoDetail.date_insert}
                      />
                    );
                  })}
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
      {typeId === "1" &&
        (environment.environmentalData?.length > 0 ? (
          <CustomSlider>
            {environment.environmentalData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  <BoxSubTitle>{infoItem.sensor_address}</BoxSubTitle>
                  {infoItem.details.map((infoDetail, index) => {
                    return (
                      <BoxEntity
                        key={index}
                        icon={`https://korydallos.smartiscity.gr/gallery/vars/Big/${infoDetail.sensorvar_icon}`}
                        content={infoDetail.sensorvar_description}
                        value={`${parseInt(infoDetail.measurement).toFixed(
                          2
                        )} ${infoDetail.sensorvar_unit}`}
                        date={infoDetail.date_insert}
                      />
                    );
                  })}
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
      {typeId === "12" &&
        (hum ? (
          <CustomSlider>
            {hum?.humData && renderItems(0, 8, hum?.humData?.group)}
            {
              // hum?.humData.group.map((infoItem, index) => {
              //   return (
              //     <BoxEntity
              //       key={index}
              //       icon={`im im-icon-On-Off-3`}
              //       content={infoItem.group_name}
              //       value={`${parseInt(infoItem.group_val).toFixed(2)} ${
              //         infoItem.sensorvar_unit
              //       }`}
              //     />
              // <div key={index}>
              //   {/* <BoxSubTitle>{infoItem.group_name}</BoxSubTitle> */}
              //   {/* {infoItem.details.map((infoDetail, index) => {
              //     return (
              //     );
              //   })} */}
              // </div>
              //   );
              // })
            }
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
    </>
  );
};

export default Meteor;
